<template>
  <!--<div>-->
  <div class="mobileBox">
    <!--banner+导航-->
    <div class="bannerBox" >
      <!--<img  ref="homeBanner" src="../../../assets/img/onlineBanner.jpg"/>-->
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->

      </div>
    </div>

    <div class="ourAppContent">
      <div class="ourApp01" id="m1">
        <div class=" animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'" style="height: 100%;width: 100%;">
          <div class="rightBox">
            <div class="titleBox">下载SuperiorPay手机应用</div>
            <div class="contentBox">资金管理，收款，查账等多功能一体式聚合APP.</div>
          </div>
          <div class="leftBox"><img src="../../../assets/icon/ourAppImg2.png"/></div>
          <div class="rightBox">
            <div class="btnBox">
              <div class="leftBtnBox">
                <img @click="linkDownload('https://itunes.apple.com/au/app/superiorpay-au/id1434379165?mt=8')" src="../../../assets/icon/ourAppBtn1.png"/>
              </div>
              <div class="leftBtnBox">
                <img @click="linkDownload('https://play.google.com/store/apps/details?id=com.silots.merchant.au')" src="../../../assets/icon/ourAppBtn2.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="ourApp02" id="m2">
        <div class=" animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'" style="height: 100%;width: 100%;">
          <div class="leftBox"><img src="../../../assets/icon/ourAppImg2.png"/></div>
          <div class="rightBox">
            <div class="titles">Check your accounts any time any where</div>
            <div class="contents">Never miss a transaction with our real-time notification.</div>
          </div>
        </div>
      </div>
      <div class="ourApp03" id="m3">
        <div class=" animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'" style="height: 100%;width: 100%;">
          <div class="leftBox">
            <div class="titles">Easy manage <br/>transactions & offers</div>
            <div class="contents">Manage transactions and offers with a single click</div>
          </div>
          <div class="rightBox">
            <img src="../../../assets/icon/ourAppImg3.png"/>
          </div>
        </div>
      </div>
      <div class="ourApp02" id="m4">
        <div class="contentW animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'" style="height: 100%;">
          <div class="leftBox"><img src="../../../assets/icon/ourAppImg4.png"/></div>
          <div class="rightBox">
            <div class="titles">Multi-platform support</div>
            <div class="contents">Manage your business via PC and mobile devices</div>
          </div>
        </div>
      </div>-->
    </div>


    <!--底部-->
    <div class="footer_m ">
      <div class="footer_mText">
        Supay Technology Pty Ltd. Authorized Representative Number 001283947
        <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
      </div>
    </div>

  </div>
  <!--</div>-->
</template>

<script>
  import topNav from './nav_m'
  let timer = null; //定义初始值
  export default {
    name: "ourApp_m",
    components:{topNav},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        animates:{
          mm1:false,
          mm2:false,
          mm3:false,
          mm4:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;

      this.animates.mm1 = true;

      // window.addEventListener('scroll', this.handleScroll)

    },
    methods:{

      //打开新连接
      linkDownload (url) {
        window.open(url,'_blank') // 新窗口打开外链接
      },

      // handleScroll () {
      //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //
      //   // var offsetTop1 = document.querySelector('#m1').offsetTop;
      //   var offsetTop2 = document.querySelector('#m2').offsetTop;
      //   var offsetTop3 = document.querySelector('#m3').offsetTop;
      //   var offsetTop4 = document.querySelector('#m4').offsetTop;
      //
      //
      //   if (scrollTop > offsetTop2-800) {
      //     this.animates.mm2 = true
      //   } else {
      //     this.animates.mm2 = false
      //   }
      //   if (scrollTop > offsetTop3-800) {
      //     this.animates.mm3 = true
      //   } else {
      //     this.animates.mm3 = false
      //   }
      //   if (scrollTop > offsetTop4-800) {
      //     this.animates.mm4 = true
      //   } else {
      //     this.animates.mm4 = false
      //   }
      // },

      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>
  .mobileBox{width: 100%;height: auto;}
  /*.mobileBox .topBanner{width: 100%;height: auto;position: relative;}*/
  /*.mobileBox .topBanner .bannerImg{width: 100%;height: auto;}*/

  /*模块2*/
  .ourApp02{width: 100%;height: 35rem;background-color: #fff;padding: 10rem 0;}
  .ourApp02 .leftBox{width: 50%;height: 100%; float: left;display: flex;align-items: center;}
  .ourApp02 .leftBox>img{align-items: center;margin: auto;max-width: 100%;}
  .ourApp02 .rightBox{width: 45%;height: 100%;float: right;}
  .ourApp02 .rightBox .titles{width: 80%; font-size: 2.25rem;font-family: Montserrat300;color: #4a4a4a;line-height: 3.5rem;margin-top:10rem;}
  .ourApp02 .rightBox .contents{width: 70%;font-size: 1.25rem;font-family: Montserrat300;color: #4a4a4a;line-height: 1.8rem;margin-top:2rem;}

  /*模块3*/
  .ourApp03{width: 100%;height: 46rem;background-color: #090723;padding: 5rem 0;}
  .ourApp03 .rightBox{width: 45%;height: 100%; float: right;display: flex;align-items: center;}
  .ourApp03 .rightBox>img{align-items: center;width: 75%;}
  .ourApp03 .leftBox{width: 50%;height: 100%;float: left;}
  .ourApp03 .leftBox .titles{width: 80%; font-size: 2.25rem;font-family: Montserrat300;color: #fff;line-height: 3.5rem;margin-top:10rem;}
  .ourApp03 .leftBox .contents{width: 70%;font-size: 1.25rem;font-family: Montserrat300;color: #fff;line-height: 1.8rem;margin-top:2rem;}




  .ourAppContent{width: 100%;height: auto;}

  /*模块1*/
  .ourApp01{width: 100%;height: auto;background-color: #090723;padding-top: 3.5rem;}
  .ourApp01 .leftBox{width: 100%;height: auto;display: flex;align-items: center;margin-top: 3rem;}
  .ourApp01 .leftBox>img{align-items: center;margin: auto;width: 90%;height: auto;}
  .ourApp01 .rightBox{width: 100%;height: auto;}
  .ourApp01 .rightBox .titleBox{width: calc(100% - 60px);margin: auto;min-width: 20rem; text-align: center; font-size: 1.5rem;font-family: Montserrat300;color: #fff;line-height: 2rem;margin-top:4rem; }
  .ourApp01 .rightBox .contentBox{width: calc(100% - 60px);margin: auto;min-width: 20rem;text-align: center;font-size: 0.875rem;font-family: Montserrat300;color: #fff;line-height: 1.8rem;margin-top:2rem;}
  .ourApp01 .rightBox .btnBox{width: 100%;height: auto;margin-top: 3rem;margin-bottom: 3rem;}
  .ourApp01 .rightBox .btnBox .leftBtnBox{width: 10rem;height: 2.9rem;border-radius: 4px;cursor: pointer;margin: 2rem auto;}
  .ourApp01 .rightBox .btnBox .leftBtnBox>img{width: 100%}
  /*.ourApp01 .rightBox .btnBox .leftBtnBox:nth-of-type(2){margin-left: 3rem;}*/

  .hideBox{display: none;}



</style>
